import React, { useState } from "react";
import InstaLogo from "../assets/instagram-logo-gradient-transparent.png"
import WhatsLogo from "../assets/whatsapp_logo.png"
import MapsLogo from "../assets/maps_logo.png"
import {AiOutlineClose, AiOutlineMenu} from 'react-icons/ai'

const Navbar = () => {
  const [nav, setNav] = useState(true)

  const handleNav = () => {
    setNav(!nav)
  }

  return (
    <div className="flex justify-between items-center h-24 max-w-full min-w-min px-4 text-white bg-opacity-10 bg-white">
      <h1 className="w-full text-3xl font-bold m-0 text-[#fcfcfc]">
        <img className="object-fit min-w-fit" alt="/" src="https://d335luupugsy2.cloudfront.net/cms/files/549112/1670431766/$8g2edkjbvct"></img>
      </h1>
      
      {/* <img className="snap-center" src="https://d335luupugsy2.cloudfront.net/cms/files/549112/1670431766/$8g2edkjbvct"></img> */}
      
      <ul className="hidden md:flex"> 
        {/* <li className="p-3 m-1 hover:bg-[#61c62c] hover:text-black rounded-2xl">eLav</li> */}

        <li className="p-4 m-2 hover:bg-[#61c62c] hover:cursor-pointer hover:text-black rounded-2xl duration-300 flex justify-center items-center">
          <img className="w-5 m-1" src={WhatsLogo} alt="/"></img>
          <a 
            className="w-full" 
            href="https://api.whatsapp.com/send/?phone=5541992636949&text=Ol%C3%A1%21+Vim+do+Google+e+gostaria+de+tirar+d%C3%BAvidas.&type=phone_number&app_absent=0"
            onClick={(e) => {
              e.preventDefault();
              window.gtag_report_conversion("https://api.whatsapp.com/send/?phone=5541992636949&text=Ol%C3%A1%21+Vim+do+Google+e+gostaria+de+tirar+d%C3%BAvidas.&type=phone_number&app_absent=0");
            }}
          >Contato</a>
        </li>

        <li className="p-4 m-2 hover:bg-[#61c62c] hover:cursor-pointer hover:text-black rounded-2xl duration-300 flex justify-center items-center">
          <img className="w-7" src={InstaLogo} alt="/"></img>
          <a className="w-full" href="https://www.instagram.com/elav.seminario/">Instagram</a>
        </li>
        
        <li className="p-4 m-2 hover:bg-[#61c62c] hover:cursor-pointer hover:text-black rounded-2xl duration-300 flex justify-center items-center">
          <img className="w-6" src={MapsLogo} alt="/"></img>
          <a className="w-full" href="https://maps.app.goo.gl/1iRk6VVTaSfCt4mY8" alt="/">Mapa</a>
        </li>
      </ul>
      
      <div onClick={handleNav} className="block md:hidden">
        {
          !nav ? <AiOutlineClose size={20}/> : <AiOutlineMenu size={20}/>
        }
      </div>

      <div className={!nav ? 'fixed left-0 top-0 w-[15%] min-w-[240px] h-full bg-[#292b53] border-r border-r-gray-900 ease-in-out duration-300 md:hidden' : 'fixed left-[-100%]'}>
        <div className="divide-y divide-white">
          <h1 className="w-full text-3xl font-bold m-2 text-[#fcfcfc]">
            <img className="object-fit min-w-fit" alt="/" src="https://d335luupugsy2.cloudfront.net/cms/files/549112/1670431766/$8g2edkjbvct"></img>
          </h1>
          
          <ul className="pt-0 uppercase">
          
            <li className="p-4 m-1 hover:bg-[#61c62c] hover:cursor-pointer hover:text-black rounded-2xl duration-300 flex justify-start items-center border-b border-gray-600">
              <img className="w-5 m-1" src={WhatsLogo} alt="/"></img>
              <a 
                className="w-full" 
                href="https://api.whatsapp.com/send/?phone=5541992636949&text=Ol%C3%A1%21+Vim+do+Google+e+gostaria+de+tirar+d%C3%BAvidas.&type=phone_number&app_absent=0"
                onClick={(e) => {
                  e.preventDefault();
                  window.gtag_report_conversion("https://api.whatsapp.com/send/?phone=5541992636949&text=Ol%C3%A1%21+Vim+do+Google+e+gostaria+de+tirar+d%C3%BAvidas.&type=phone_number&app_absent=0");
                }}
              >Contato</a>
            </li>
            
            <li className="p-4 m-1 hover:bg-[#61c62c] hover:cursor-pointer hover:text-black rounded-2xl duration-300 flex justify-start items-center border-b border-gray-600">
              <img className="w-7" src={InstaLogo} alt="/"></img>
              <a className="w-full" href="https://www.instagram.com/elav.seminario/">Instagram</a>
            </li>
            
            <li className="p-4 m-1 hover:bg-[#61c62c] hover:cursor-pointer hover:text-black rounded-2xl duration-300 flex justify-start items-center border-b border-gray-600">
              <img className="w-6" src={MapsLogo} alt="/"></img>
              <a className="w-full" href="https://maps.app.goo.gl/1iRk6VVTaSfCt4mY8" alt="/">Mapa</a>
            </li>
          
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Navbar